module.exports = __webpack_public_path__ + "media/images/konintodoke/top_mv/konintodoke00007-558a6fb5ad6bce2eed8d23839ca29687.jpg";